// <- TaskManagment.js
import React, { useState, Fragment,useEffect  } from "react";
import { Button, ListGroup, ListGroupItem } from "reactstrap";
import TableWithSortPagtn from "../../common/TableForListAppraisalForLeader";
import DropDownActions from "../../common/DropDownActions";
import moment from 'moment';
import api from "../../../apis/api";
import Notifications from "../../common/Notifications";
import LoadingOverlay from "react-loading-overlay";
import styled, { css } from "styled-components";

const active = {
  background: "rgba(114, 111, 111, 0.048)",
};
const loginUser = JSON.parse(localStorage.getItem("user"));
let sumhours=0;
let sumbillable=0;
let estimated=0;
let maxwidth="80vw";
const ListAppraisalForLeader = React.memo(
  ({

    reviewAppraiseeList,
    reviewAppraisal
    
  }) => {
    const [thead] = useState([
          "#",
          "Employee Name",
          "Status",
          "Action"
           
        ]);
    const [trow, setTrow] = useState([]);
    const [activeTask, setActiveTask] = useState(0);
   const [curstatus,setcurstatus] =useState(0);
   const [curstatusList,setcurstatusList] = useState([]);
   const [reason,setreason] = useState("");
   const [error, setError] = useState(null);
   const [loaded, setLoaded] = useState(false);
   
   const DarkBackground = styled.div`
   display: none; /* Hidden by default */
     position: fixed; /* Stay in place */
     z-index: 999; /* Sit on top */
     left: 0;
     top: 0;
     width: 100%; /* Full width */
     height: 100%; /* Full height */
     overflow: auto; /* Enable scroll if needed */
     background-color: rgb(0, 0, 0); /* Fallback color */
     background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
   ${(props) =>
     props.disappear &&
     css`
       display: block; /* show */
     `}
   `;
   
      useEffect(()=>{
          if (reviewAppraiseeList && reviewAppraiseeList.length > 0) {
     let trow = [...reviewAppraiseeList].reverse().map((el,i) => ({
            "#":<div style={{width:'100px'}}>{i+1}</div>,
            "Employee Name": (
             <div style={{width:'140px'}}><h2 className="table-avatar">
    
                <span className="ml-2">
                  <span style={{ fontWeight: "400", color: "black" }}>
                    {el.employeeName}
                  </span>
                  {/* <span> {el.empDesignation}</span> */}
                </span>
              </h2></div>
            ),
            "Status":<div style={{width:'100px'}}>{el.status}</div>,
            "Action": <div style={{width:'100px'}}>
                      <input type="button"
                      value="Review" 
                      className='btn-admin-settings btn' 
                      onClick={(e) => reviewAppraisal(el.appraiseeId,el.reviewType)}
                      style = {el.reviewBtnStatus?{display:"block"}:{display:'none'}}
                      
                      /></div>,
            
          }));
       
          // trow.sort((a, b) => a["#"] - b["#"]);
          setTrow([...trow].reverse());
        }
             },[reviewAppraiseeList])
    
    return (
      <Fragment>
       
        <div className="" style={{ maxWidth: maxwidth, overflowY: "auto" }}>
      <TableWithSortPagtn thead={thead} trow={trow} pageSize={5} reviewAppraisal={reviewAppraisal} disablePagination={false}></TableWithSortPagtn>
    </div>
    <Notifications notifications={error}></Notifications>
    <DarkBackground disappear={loaded}>
    <LoadingOverlay
          active={true}
          spinner={true}
          text="Loading your content..."
        >
        </LoadingOverlay>
    </DarkBackground>
       
      </Fragment>
    );
  }
);

export default ListAppraisalForLeader;
